import {FC, useMemo} from 'react'
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import HighchartsReact from 'highcharts-react-official'
import {CGERegionResult} from '../core/_models'
import {divergingColor} from './chartColors'

type CGERegionsChartProps = {
  regions: CGERegionResult[]
}

const CGERegionsChart: FC<CGERegionsChartProps> = ({regions}) => {
  const options = useMemo(
    () => ({
      chart: {type: 'column', height: 360, backgroundColor: 'transparent'},
      title: {text: ''},
      xAxis: {categories: regions.map((r) => r.name), labels: {style: {fontSize: '0.8rem'}}},
      yAxis: {title: {text: 'Welfare (US$M, EV)'}},
      legend: {enabled: false},
      credits: {enabled: false},
      tooltip: {
        pointFormatter: function (this: any) {
          return `Welfare: <b>US$ ${this.y.toLocaleString()}M</b>`
        },
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          dataLabels: {enabled: true, format: '{y}'},
        },
      },
      series: [
        {
          name: 'Welfare impact',
          data: regions.map((r) => ({
            y: r.welfare_ev_usd_mn,
            color: divergingColor(r.welfare_ev_usd_mn),
          })),
        },
      ],
    }),
    [regions]
  )

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export {CGERegionsChart}
